import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Wrench } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex items-center gap-3 text-slate-600">
          <Wrench className="w-5 h-5 animate-pulse text-blue-900" />
          <span className="font-medium">Yükleniyor...</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    // Update 29.8 — Tüm roller için Kontrol Paneli'ne yönlendir; eski
    // "data_entry → /veri-giris" ve "viewer → /is-emirleri" kuralları KALDIRILDI.
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
